@let form = stockLocationPriceForm();
@let isReadonly = readonly();
<dx-grid mq1="12/*" [mq4]="mq4()" [formGroup]="form">
  <dx-number-input
    *artHasFormControl="[form, 'units']"
    formControlName="units"
    label="{{ 'artwork.units' | transloco }}"
    required="true"
    min="1"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: 0 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-number-input
    *artHasFormControl="[form, 'customerPrice']"
    formControlName="customerPrice"
    unit="€"
    precision="2"
    label="{{ 'artwork.gallery-price' | transloco }}"
    required="true"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-number-input
    *artHasFormControl="[form, 'minimumPrice']"
    formControlName="minimumPrice"
    unit="€"
    precision="2"
    label="{{ 'artwork.minimum-price' | transloco }}"
    required="true"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-number-input
    *artHasFormControl="[form, 'auctionPrice']"
    formControlName="auctionPrice"
    unit="€"
    precision="2"
    label="{{ 'artwork.auction-price' | transloco }}"
    required="true"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-number-input
    *artHasFormControl="[form, 'carriage']"
    formControlName="carriage"
    unit="€"
    precision="2"
    label="{{ 'artwork.transport-cost' | transloco }}"
    required="true"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-number-input
    *artHasFormControl="[form, 'artistShare']"
    formControlName="artistShare"
    unit="€"
    precision="2"
    label="{{ 'artwork.artist-share' | transloco }}"
    required="true"
    min="0"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: -1 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <dx-text-input
    *artHasFormControl="[form, 'location']"
    label="{{ 'artwork.location' | transloco }}"
    required="true"
    readonly
    [value]="form.get('location')?.value?.name"
  >
  </dx-text-input>
  <dx-number-input
    *artHasFormControl="[form, 'stock']"
    formControlName="stock"
    [errormessage]="form?.errors?.['unitsLessThanStock'] ? ('artwork.stock-error' | transloco) : null"
    label="{{ 'artwork.stock' | transloco }}"
    required="true"
    min="1"
    nominmaxlabel="true"
    artCustomNumberError
    [artCustomNumberErrorMessage]="'error.min-input' | transloco: { min: 0 }"
    [artCustomNumberErrorType]="NumberErrorType.UNDER_MIN"
    (controlError)="updateControlErrors($event)"
    [readonly]="isReadonly"
  ></dx-number-input>
  <div *artHasFormControl="[form, 'locations']" formArrayName="locations">
    @for (locationCtrl of locations.controls; track locationCtrl; let idx = $index) {
      <div [formGroupName]="idx">
        <dx-grid mq1="8-4/*">
          <dx-text-input
            readonly="true"
            label="{{ 'artwork.location' | transloco }} {{ idx + 1 }}"
            required="true"
            [value]="locations.at(idx).get('location')?.value?.name"
          ></dx-text-input>

          <dx-number-input
            formControlName="stock"
            label="{{ 'artwork.stock' | transloco }}"
            required="true"
            [readonly]="isReadonly"
          ></dx-number-input>
        </dx-grid>
      </div>
    }
  </div>
</dx-grid>
